// extracted by mini-css-extract-plugin
export default {"zoomModal":"U0-z","image":"V0-z","button":"W0-z","isOverlayShown":"X0-z"};